<form [formGroup]="checkboxForm" (ngSubmit)="onSubmit()">
  <span class="font-bold text-gray-600">{{label.toUpperCase()}}</span>

  <div formArrayName="selectedItems">
    @for (control of itemControls; track control; let i = $index) {
      <div class="checkbox-row">
        <mat-checkbox [formControlName]="i" (change)="onSubmit()">
          {{ items[i].name }}
        </mat-checkbox>
      </div>
    }
  </div>
</form>
